/**
 * Custom JavaScript for Retrospillkongen.
 * Theme hooks available: document events 'variant:changed', 'product:added', and
 * 'cart:refresh' (dispatch on document.documentElement to re-render the mini-cart).
 */

const observer = new MutationObserver(() => {
  document.querySelectorAll(".jdgm-prev-badge__text").forEach((el) => {
    if (/reviews?/i.test(el.textContent)) {
      el.textContent = el.textContent.replace(/reviews?/gi, "").trim();
    }
  });
});
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener("DOMContentLoaded", () => {
  function handleClickAndScroll() {
    const buttonToClick = document.querySelector("#judgebutton > span.plus-button.plus-button--large");
    if (buttonToClick) {
      buttonToClick.click();
      buttonToClick.scrollIntoView({ behavior: "smooth" });
    }
  }
  const jdgmPrevBadge = document.querySelector(".jdgm-prev-badge");

  if (jdgmPrevBadge) {
    jdgmPrevBadge.addEventListener("click", handleClickAndScroll);
  }
});

window.addEventListener("load", (event) => {
  if (window.location.search.includes("judgeme_token")) {
    document.querySelector("#judgebutton").click();
    revTabInterval = setInterval(function () {
      jdgm._openReviewTab();
      jdgm.openForm(jdgm.visibleRevWidget());
      jdgm._appendCustomForm(jdgm.visibleRevWidget());
      jdgm._scrollDownToWidget();

      var observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting === true) clearInterval(revTabInterval);
        },
        { threshold: [0] },
      );
      observer.observe(document.querySelector("#judgeme_product_reviews"));
    }, 1000);
  }
  if (window.location.hash === "#judgeme_product_reviews") {
    document.querySelector("#judgebutton").click();
  }
});

/**
 * Handlekurv-anbefalinger ("Du vil kanskje ogsaa like") i mini-cart-slideren.
 * Web-component som henter komplementaerprodukter (fallback: relaterte) via Shopify
 * sitt anbefalings-endepunkt og fyller inn seksjonen cart-recommendations.liquid.
 * connectedCallback kjoerer hver gang mini-cart re-renders, saa den holder seg oppdatert.
 */
(function () {
  if (!window.customElements || customElements.get("cart-recommendations")) return;

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      var productId = this.getAttribute("product-id");
      if (!productId || this.dataset.loaded) return;
      this.dataset.loaded = "1";
      this._load(productId);
    }

    _url(productId, intent) {
      var base = (window.routes && window.routes.rootUrlWithoutSlash) || "";
      return (
        base +
        "/recommendations/products?product_id=" +
        encodeURIComponent(productId) +
        "&limit=10&intent=" +
        intent +
        "&section_id=cart-recommendations"
      );
    }

    _extract(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var el = doc.querySelector(".mini-cart-recs");
      return el && el.querySelector(".product-item") ? el : null;
    }

    _load(productId) {
      var self = this;
      fetch(this._url(productId, "complementary"))
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var el = self._extract(html);
          if (el) {
            self.appendChild(el);
            self._wireArrows();
            return;
          }
          return fetch(self._url(productId, "related"))
            .then(function (r) {
              return r.text();
            })
            .then(function (html2) {
              var el2 = self._extract(html2);
              if (el2) {
                self.appendChild(el2);
                self._wireArrows();
              }
            });
        })
        .catch(function () {});
    }

    _wireArrows() {
      var scroller = this.querySelector("[data-cart-recs-scroller]");
      var prev = this.querySelector("[data-cart-recs-prev]");
      var next = this.querySelector("[data-cart-recs-next]");
      if (!scroller) return;

      function step() {
        // Én "side" = de 3 synlige kortene
        return scroller.clientWidth;
      }
      if (prev) {
        prev.addEventListener("click", function () {
          scroller.scrollBy({ left: -step(), behavior: "smooth" });
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          scroller.scrollBy({ left: step(), behavior: "smooth" });
        });
      }

      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth - 2;
        if (prev) prev.hidden = scroller.scrollLeft <= 2;
        if (next) next.hidden = scroller.scrollLeft >= max;
      }
      scroller.addEventListener("scroll", update, { passive: true });
      update();
    }
  }

  customElements.define("cart-recommendations", CartRecommendations);
})();

/**
 * Auto-korriger "Alternativ" ved språkbytte (og andre valg):
 * Når et valg endres og den resulterende kombinasjonen er utsolgt/utilgjengelig,
 * hopper de ANDRE valgene automatisk til første tilgjengelige (på lager) verdi.
 * Kjører etter temaets 'product:rerender' så den er uavhengig av nettverks-timing.
 * Et direkte klikk på et utsolgt alternativ respekteres (overstyres ikke), slik at
 * "gi beskjed når på lager" fortsatt fungerer. Viser en kort rød OBS-melding over pris.
 */
(function () {
  if (window.__rkVariantAutoStock) return;
  window.__rkVariantAutoStock = true;

  var lastChangedPos = null;
  var noticeTimer = null;
  var justCorrected = false;

  function removeNotice() {
    var n = document.querySelector(".rk-variant-notice");
    if (n) n.remove();
  }

  function showNotice(form) {
    removeNotice();
    var list = form.querySelector(".product-form__info-list");
    var picker = form.querySelector("variant-picker");
    var msg = document.createElement("div");
    msg.className = "rk-variant-notice";
    msg.setAttribute("role", "status");
    msg.textContent = "OBS: Alternativ ble endret.";
    msg.style.cssText =
      "color:#d81e05;font-weight:600;font-size:13px;line-height:1.3;margin:10px 0;";
    if (list && list.parentNode) {
      list.parentNode.insertBefore(msg, list); // rett over pris
    } else if (picker && picker.parentNode) {
      picker.parentNode.insertBefore(msg, picker.nextSibling);
    } else {
      return;
    }
    if (noticeTimer) clearTimeout(noticeTimer);
    noticeTimer = setTimeout(removeNotice, 6000);
  }

  function isUnavailable(input) {
    var w = input.closest(".block-swatch, .color-swatch, .variant-swatch");
    return w ? /--disabled/.test(w.className) : false;
  }

  document.addEventListener(
    "change",
    function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[data-option-position], select[data-option-position]')) {
        if (!t.__rkAuto) {
          lastChangedPos = t.getAttribute("data-option-position");
          justCorrected = false;
          removeNotice();
        }
      }
    },
    true,
  );

  // Kjører etter at temaet har re-rendret variant-blokken (DOM er da oppdatert).
  function correct(form) {
    if (!form || !form.querySelectorAll) return;
    var dv = {};
    try {
      dv = JSON.parse(form.querySelector('variant-picker script[data-variant]')?.textContent || "{}");
    } catch (_) {}
    if (dv && dv.available) {
      // Kombinasjonen er (igjen) på lager. Hvis vi nettopp auto-korrigerte, vis melding.
      if (justCorrected) {
        showNotice(form);
        justCorrected = false;
      }
      return;
    }
    var groups = form.querySelectorAll(".product-form__option");
    for (var gi = 0; gi < groups.length; gi++) {
      var inputs = groups[gi].querySelectorAll("input[data-option-position]");
      if (!inputs.length) continue; // hopp over dropdown-velgere
      var pos = inputs[0].getAttribute("data-option-position");
      if (pos === lastChangedPos) continue; // behold valget brukeren nettopp endret
      var checked = null,
        firstAvail = null;
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) checked = inputs[i];
        if (!firstAvail && !isUnavailable(inputs[i])) firstAvail = inputs[i];
      }
      if (checked && isUnavailable(checked) && firstAvail && firstAvail !== checked) {
        firstAvail.__rkAuto = true;
        firstAvail.checked = true;
        justCorrected = true;
        firstAvail.dispatchEvent(new Event("change", { bubbles: true }));
        break; // ett bytte trigger et helt nytt oppslag + ny rerender
      }
    }
  }

  document.addEventListener("variant:changed", function (e) {
    var form = e.target;
    if (!form || form.tagName !== "FORM") return;
    if (!form.__rkRerenderBound) {
      form.__rkRerenderBound = true;
      // 'product:rerender' bobler ikke og må lyttes på formen. Vår handler registreres
      // etter temaets ProductRerender, så DOM er ferdig byttet når vi kjører.
      form.addEventListener("product:rerender", function () {
        setTimeout(function () {
          correct(form);
        }, 0);
      });
    }
  });
})();
